import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import User from "../../APIController/User";
import Form from "../../Components/Form";
import Text from "../../Components/Text";
import TextInput from "../../Components/Form/TextInput";
import Button from "../../Components/Buttons/Button";
import Snackbar from "../../Components/Elements/Snackbar";
import Icon from "../../Components/Icon";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const navigate = useNavigate();
  const { login } = User();

  const handleSignUp = () => {
    navigate("/register");
  };

  const handleReset = () => {
    navigate("/send_reset")
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    const body = {
      email: email,
      password: password
    }
    const loginResponce = await login(body)
    if (loginResponce.ok) {
      navigate("/search");
    } else {
      setSnackbarMessage("Username oder Passwort falsch");
    }
  };

  return (
    <>
      <Form onSubmitAction={handleLogin} submitButtonText={"Login"} size="w-full" background="bg-white" border="">
        <Text type="maintitle" classNames={"flex text-center justify-center"}>{"Login"}</Text>
        <TextInput placeholder={"E-Mail"} action={(e) => setEmail(e.target.value)} type={"email"}></TextInput>
        <TextInput placeholder={"Password"} action={(e) => setPassword(e.target.value)} type={"password"}></TextInput>
      </Form>
      <div className="flex flex-row items-center p-2">
        <Text type="buttontext">Kein Account?</Text>
        <Button classNames="text-blue-500 hover:underline" buttonColor="transparent" borderStyle="" text={"Jetzt registrieren"} onClickAction={() => handleSignUp()} />
      </div>
      <div className="flex flex-row items-center p-2" >
        <Button classNames="text-blue-500 hover:underline" buttonColor="transparent" borderStyle="" text={"Password Vergessen?"} onClickAction={() => handleReset()} />
      </div>
      <Snackbar message={snackbarMessage} onClose={() => setSnackbarMessage("")} />
    </>
  );
};

export default LoginPage;
